import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "name" }
const _hoisted_2 = {
  key: 1,
  class: "sortable"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table-head", {pointer: $props.sortable}])
  }, [
    ($props.checkbox)
      ? (_openBlock(), _createBlock(_component_Checkbox, {
          key: 0,
          "model-value": $props.selected,
          indeterminate: $props.indeterminate,
          disabled: $props.disabled,
          size: "large",
          style: {"display":"flex"},
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
          onChange: _cache[1] || (_cache[1] = $event => (_ctx.$emit('change', $event)))
        }, null, 8 /* PROPS */, ["model-value", "indeterminate", "disabled"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("span", _hoisted_1, _toDisplayString($props.name), 1 /* TEXT */),
    ($props.sortable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($props.sortOrder === 1)
            ? (_openBlock(), _createBlock(_component_Icon, {
                key: 0,
                class: "pointer",
                width: "1.6rem",
                height: "1.6rem",
                icon: "arrow-down",
                stroke: "var(--gray-600)"
              }))
            : _createCommentVNode("v-if", true),
          ($props.sortOrder === -1)
            ? (_openBlock(), _createBlock(_component_Icon, {
                key: 1,
                class: "pointer",
                width: "1.6rem",
                height: "1.6rem",
                icon: "arrow-up",
                stroke: "var(--gray-600)"
              }))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}